import React from 'react';
import { Tool, type ToolArgsWithController } from '@aha-app/aha-editor-v2';
import { whiteboardControllerForEditor } from '../EmbeddedWhiteboardControllersPluginFactory';

class ToolEditWhiteboard extends Tool {
  static toolName = 'Edit';

  static available(toolArgs: ToolArgsWithController): boolean {
    return toolArgs.controller.ahaEditor.hasPlugin(
      'EmbeddedWhiteboardControllersPlugin'
    );
  }

  static renderToolbarButtonIcon() {
    return <span className='tw-px-1'>{this.toolName}</span>;
  }

  static action({ controller, element }: ToolArgsWithController): void {
    const whiteboardController = whiteboardControllerForEditor(
      controller.ahaEditor,
      element
    );

    if (whiteboardController) {
      whiteboardController.router.navigate(
        whiteboardController.getDisplayModeUrl('fullscreen')
      );
    }
  }
}

export default ToolEditWhiteboard;
